import { externalDistributionLinks, } from 'constants/externalLinks'

export default function(product, locale) {
  return externalDistributionLinks[locale][product] || ''
}
